import React, { useState } from 'react';
import { BaseConfigProps, commonStyles } from '../shared/ConfigFormHelpers';
import CollapsibleSection from '../shared/CollapsibleSection';

const FlintSignConfig: React.FC<BaseConfigProps> = ({ node, updateConfig }) => {
  const [expandedSections, setExpandedSections] = useState<Set<string>>(new Set(['api', 'signature']));
  
  const toggleSection = (section: string) => {
    setExpandedSections(prev => {
      const newSet = new Set(prev);
      if (newSet.has(section)) {
        newSet.delete(section);
      } else {
        newSet.add(section);
      }
      return newSet;
    });
  };

  return (
    <div className="space-y-3">
      {/* API Beállítások */}
      <CollapsibleSection
        id="api"
        title="FlintSign API"
        icon="🔐"
        color="emerald"
        isExpanded={expandedSections.has('api')}
        onToggle={toggleSection}
      >
        <div className="space-y-3">
          <div>
            <label className={commonStyles.smallLabel}>
              API Kulcs
            </label>
            <input
              type="password"
              value={node.data.config.apiKey || ''}
              onChange={(e) => updateConfig('apiKey', e.target.value)}
              className={commonStyles.input}
              placeholder="FlintSign API kulcs"
            />
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
              FlintSign fiókból származó API kulcs
            </p>
          </div>

          <div>
            <label className={commonStyles.smallLabel}>
              Tanúsítvány ID
            </label>
            <input
              type="text"
              value={node.data.config.certificateId || ''}
              onChange={(e) => updateConfig('certificateId', e.target.value)}
              className={commonStyles.input}
              placeholder="cert_12345..."
            />
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
              Használandó digitális tanúsítvány azonosítója
            </p>
          </div>
        </div>
      </CollapsibleSection>

      {/* Aláírás Beállítások */}
      <CollapsibleSection
        id="signature"
        title="Aláírás Beállítások"
        icon="✍️"
        color="blue"
        isExpanded={expandedSections.has('signature')}
        onToggle={toggleSection}
      >
        <div className="space-y-3">
          <div>
            <label className={commonStyles.smallLabel}>
              Bemeneti Fájl
            </label>
            <input
              type="text"
              value={node.data.config.inputFile || ''}
              onChange={(e) => updateConfig('inputFile', e.target.value)}
              className={commonStyles.input}
              placeholder="/path/to/document.pdf vagy {{file}}"
            />
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
              Aláírandó PDF fájl elérési útja vagy változó
            </p>
          </div>

          <div>
            <label className={commonStyles.smallLabel}>
              Aláírás Pozíció
            </label>
            <select
              value={node.data.config.signaturePosition || 'bottom-right'}
              onChange={(e) => updateConfig('signaturePosition', e.target.value)}
              className={commonStyles.select}
            >
              <option value="top-left">Bal felső</option>
              <option value="top-right">Jobb felső</option>
              <option value="bottom-left">Bal alsó</option>
              <option value="bottom-right">Jobb alsó</option>
              <option value="center">Középen</option>
            </select>
          </div>

          <div>
            <label className={commonStyles.smallLabel}>
              Aláírás Indoka
            </label>
            <input
              type="text"
              value={node.data.config.signatureReason || 'Digitális aláírás'}
              onChange={(e) => updateConfig('signatureReason', e.target.value)}
              className={commonStyles.input}
              placeholder="Dokumentum jóváhagyása"
            />
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
              Az aláírás céljának megjelölése
            </p>
          </div>
        </div>
      </CollapsibleSection>

      {/* Fájl Információk */}
      <CollapsibleSection
        id="file"
        title="Fájl Kezelés"
        icon="📄"
        color="gray"
        isExpanded={expandedSections.has('file')}
        onToggle={toggleSection}
      >
        <div className="space-y-2">
          <div className="text-xs text-gray-600 dark:text-gray-400">
            <strong>Bemenet:</strong> PDF fájl
          </div>
          <div className="text-xs text-gray-600 dark:text-gray-400">
            <strong>Kimenet:</strong> Aláírt PDF fájl
          </div>
          <div className="text-xs text-gray-600 dark:text-gray-400">
            <strong>Támogatott formátumok:</strong> PDF
          </div>
          <div className="text-xs text-gray-500 dark:text-gray-500 mt-2 p-2 bg-gray-50 dark:bg-gray-700 rounded">
            💡 A FlintSign csak PDF dokumentumokat tud digitálisan aláírni. Az aláírt fájl az eredeti fájlnév elé "signed_" előtaggal kerül mentésre.
          </div>
        </div>
      </CollapsibleSection>
    </div>
  );
};

export default FlintSignConfig;
